import { Modal, inputCls, btnPrimary, btnTurq } from "../bits";

export function SchoolImportModal({ open, onClose, fileRef, busy, onImport }) {
  return (
    <Modal open={open} onClose={onClose} title="استيراد المدارس والمنسقين من Excel" testid="schools-import-modal">
      <div className="space-y-4">
        <p className="text-xs text-mutext leading-relaxed">
          تُقرأ الأعمدة من عناوينها بأي ترتيب (اسم المدرسة، المرحلة، النوع، السلطة، المحافظة/المكتب، هاتف المدرسة، مدير المدرسة، عدد الطلاب، عدد الموظفين، اسم المنسق، بريد المنسق، جوال المنسق)،
          وتُطبع المرحلة تلقائياً (ابتدائي ← ابتدائية، متوسط ← متوسطة، ثانوي ← ثانوية، طفولة مبكرة ← روضة) فيرتبط كل منسق بوضع مدرسته الصحيح.
          المدرسة الموجودة (بنفس الاسم والمحافظة) تُحدَّث ولا تتكرر، والأخطاء الشائعة في البريد تُصحَّح تلقائياً، ويُنشأ حساب المنسق بكلمة مرور افتراضية Ataa@12345.
        </p>
        <input ref={fileRef} data-testid="schools-import-file" type="file" accept=".xlsx,.xlsm" className={inputCls} />
        <button data-testid="schools-import-submit" onClick={onImport} disabled={busy} className={`${btnTurq} w-full justify-center`}>
          {busy ? "جارٍ الاستيراد …" : "بدء الاستيراد"}
        </button>
      </div>
    </Modal>
  );
}

export function SchoolsReportModal({ report, onClose }) {
  return (
    <Modal open={!!report} onClose={onClose} title="تقرير استيراد المدارس" testid="schools-import-report">
      {report && (
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="rounded-xl bg-turq-100 dark:bg-surface2 p-4">
              <div data-testid="schools-created-count" className="font-head font-black text-2xl text-turq-900 dark:text-turq-300">{report.created}</div>
              <div className="text-[11px] text-mutext">مدرسة جديدة</div>
            </div>
            <div className="rounded-xl bg-beige-600 dark:bg-surface2 p-4">
              <div data-testid="schools-updated-count" className="font-head font-black text-2xl text-turq-900 dark:text-turq-300">{report.updated}</div>
              <div className="text-[11px] text-mutext">مدرسة محدّثة</div>
            </div>
            <div className="rounded-xl bg-coral-100 dark:bg-surface2 p-4">
              <div data-testid="schools-rejected-count" className="font-head font-black text-2xl text-coral-900 dark:text-coral-300">{report.rejected.length}</div>
              <div className="text-[11px] text-mutext">صف مرفوض</div>
            </div>
          </div>
          {report.rejected.length > 0 && (
            <div className="max-h-48 overflow-auto rounded-xl border border-brd">
              <table className="w-full text-xs">
                <thead><tr className="bg-coral-100 text-coral-900"><th className="px-3 py-2 text-right">الصف</th><th className="px-3 py-2 text-right">السبب</th></tr></thead>
                <tbody>
                  {report.rejected.map((r) => (
                    <tr key={r.row} data-testid={`schools-rejected-row-${r.row}`} className="border-t border-brd/50">
                      <td className="px-3 py-2 font-bold">{r.row}</td>
                      <td className="px-3 py-2">{r.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {(report.warnings || []).length > 0 && (
            <div className="rounded-xl border border-coral-600/30 bg-coral-100/40 dark:bg-surface2 p-3" data-testid="schools-import-warnings">
              <div className="text-xs font-bold text-coral-900 dark:text-coral-300 mb-1.5">تنبيهات تحتاج مراجعة ({report.warnings.length})</div>
              <ul className="text-[11px] text-mutext space-y-1 max-h-32 overflow-auto">
                {report.warnings.map((w) => <li key={w.row} data-testid={`schools-warning-row-${w.row}`}>صف {w.row}: {w.note}</li>)}
              </ul>
            </div>
          )}
          <button data-testid="schools-report-close" onClick={onClose} className={`${btnPrimary} w-full justify-center`}>تم</button>
        </div>
      )}
    </Modal>
  );
}
